import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Helpers } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';

import {
  ViewboxConsentRequestActions,
  ViewboxConsentRequestData,
  ViewboxGdprData,
  ViewboxRequestBody,
} from './types';

@Injectable({ providedIn: 'root' })
export class ViewboxGdprHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadItem(companyHost: string, candidateToken: string): Observable<ViewboxGdprData> {
    return this.httpApi
      .get(`/share/gdpr/${companyHost}/${candidateToken}`, {}, { addToken: false })
      .pipe(map(data => Helpers.fillInReferences(data.gdpr, data.references)));
  }

  public loadConsentRequestData(
    companyHost: string,
    consentToken: string,
  ): Observable<ViewboxConsentRequestData> {
    return this.httpApi
      .get(`/share/gdpr/${companyHost}/consent/${consentToken}`, {}, { addToken: false })
      .pipe(map(data => Helpers.fillInReferences(data.consentLink, data.references)));
  }

  public newRequest(
    companyHost: string,
    candidateToken: string,
    body?: ViewboxRequestBody,
  ): Observable<ViewboxGdprData> {
    return this.httpApi
      .post(`/share/gdpr/${companyHost}/${candidateToken}`, {}, body, { addToken: false })
      .pipe(map(data => Helpers.fillInReferences(data.gdpr, data.references)));
  }

  public consentRequest(
    action: Omit<ViewboxConsentRequestActions, ViewboxConsentRequestActions.Confirm>,
    companyHost: string,
    consentToken: string,
  ): Observable<ViewboxConsentRequestData> {
    return this.httpApi
      .post(`/share/gdpr/${companyHost}/consent/${consentToken}/${action}`, {}, null, {
        addToken: false,
      })
      .pipe(map(data => Helpers.fillInReferences(data.consentLink, data.references)));
  }
}
